require('../bootstrap');
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import DingHelper from '../plugins/helper';
import localization from '../localization';
import BootstrapVue from 'bootstrap-vue'

Vue.use(VueI18n);
Vue.use(DingHelper);
Vue.use(BootstrapVue);

window.Vue = Vue;
window.VueI18n = VueI18n;
window.localization = localization;

Vue.component('plans-display-only', require('../components/membership/PlansDisplayOnly.vue').default);